import React from 'react'
import { Link } from '@inertiajs/react'
import UserLayout from '../../../Layouts/UserLayout'

const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'French', flag: '🇫🇷' },
  { code: 'es', name: 'Spanish', flag: '🇪🇸' },
  { code: 'de', name: 'German', flag: '🇩🇪' },
  { code: 'it', name: 'Italian', flag: '🇮🇹' },
  { code: 'pt', name: 'Portuguese', flag: '🇵🇹' },
  { code: 'ru', name: 'Russian', flag: '🇷🇺' },
  { code: 'ja', name: 'Japanese', flag: '🇯🇵' },
  { code: 'zh', name: 'Chinese', flag: '🇨🇳' }
]

export default function Index({ tags }) {
  return (
    <UserLayout>
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Tag Management</h1>
          <Link 
            href="/admin/tags/new" 
            className="bg-emerald-600 text-white px-4 py-2 rounded hover:bg-emerald-700"
          >
            + New Tag
          </Link>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  English Name
                </th>
                {LANGUAGES.filter(l => l.code !== 'en').map(lang => (
                  <th key={lang.code} className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {lang.flag} {lang.name}
                  </th>
                ))}
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {tags.map(tag => (
                <tr key={tag.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">{tag.name_en || '—'}</div>
                  </td>
                  {LANGUAGES.filter(l => l.code !== 'en').map(lang => {
                    const fieldName = `name_${lang.code}`
                    const value = tag[fieldName]
                    return (
                      <td key={lang.code} className="px-4 py-4 whitespace-nowrap">
                        <div className={`text-sm ${value ? 'text-gray-900' : 'text-gray-400 italic'}`}>
                          {value || '—'}
                        </div>
                      </td>
                    )
                  })}
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <Link 
                      href={`/admin/tags/${tag.id}/edit`}
                      className="text-emerald-600 hover:text-emerald-900 mr-4"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          {tags.length === 0 && (
            <div className="text-center py-12 text-gray-500">
              No tags yet. Create your first tag to get started.
            </div>
          )}
        </div>
      </div>
    </UserLayout>
  )
}



